import { Route, Routes } from "react-router-dom"
import { FilesManager } from "../pages/main"
import { FilesManagerProvider } from "../provider"
import { CreateFile } from "../pages/createFile"
import { FileManagerDetail } from "../pages/detail"
import { FileManagerEdit } from "../pages/edit"

const FilesManagerRoutes = () => {
    return (
        <FilesManagerProvider>
            <Routes>
                <Route path="main" element={<FilesManager />} />
                <Route path="create" element={<CreateFile />} />
                <Route path="detail/:id" element={<FileManagerDetail />} />
                <Route path="edit/:id" element={<FileManagerEdit />} />
                {/* <Route path="/:id" element={<Form />} /> */}
            </Routes>
        </FilesManagerProvider>
    )
}

export { FilesManagerRoutes }
